/**
 * @module app.bdc.list.jdpOrderCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function JdpOrderCtrl($scope, $uibModalInstance, Notification, $log) {
        var self = {};
        self.startDate = moment().startOf('month').toDate();
        self.endDate = moment().toDate();

        self.export = function() {
            $uibModalInstance.close({
                startDate: self.startDate,
                endDate: self.endDate
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    JdpOrderCtrl.$inject = ['$scope', '$uibModalInstance', 'Notification', '$log'];

    angular.module('app.bdc.list.jdpOrderCtrl', ['ui.bootstrap']).controller('JdpOrderCtrl', JdpOrderCtrl);
});
